<div
    class="drawer a-fx-col a-fx-gap-32"
    scrollBottomTarget=".ant-drawer-body"
    (adsptScrollToBottom)="loadMoreAlerts(alertSource)"
>
    <div class="a-fx a-fx-between-center">
        <h2>
            {{ 'alert-center.alerts' | translate }}
        </h2>

        <div class="drawer-header a-fx a-fx-start-center a-fx-gap-16">
            <adspt-alerts-resolved-toggle></adspt-alerts-resolved-toggle>

            <a
                nz-button
                nzType="text"
                class="a-icon-button alerts-link"
                routerLink="/alerts"
                queryParamsHandling="preserve"
                tabindex="-1"
                adsptHeap="notifications-drawer-page-icon"
                (click)="drawerRef.close()"
            >
                <adspt-icon name="open-new-tab" />
            </a>

            <a
                nz-button
                nzType="text"
                class="a-icon-button settings-link"
                routerLink="/settings/user/alert-settings"
                queryParamsHandling="preserve"
                tabindex="-1"
                adsptHeap="notifications-settings"
                (click)="drawerRef.close()"
            >
                <adspt-icon name="settings" />
            </a>
        </div>
    </div>

    <adspt-spinner-overlay minHeight="400" [active]="loadingAlerts$ | async">
        <div
            *ngIf="alerts$ | async as alerts"
            class="alerts a-fx-col a-fx-gap-16"
            [class.a-bg-color-ligt-gray]="!!alerts.length"
        >
            <div
                *ngFor="let alert of alerts; trackBy: trackByAlert"
                class="alert"
                [class.resolved]="alert.cleared"
                [ngClass]="alert.read ? 'a-bg-color-unfocus' : 'a-bg-color-white'"
            >
                <div class="alert-header a-fx a-fx-between-center a-fx-gap-16">
                    <div class="a-fx a-fx-start-center a-fx-gap-8 a-fx-flex">
                        <adspt-alerts-severity-icon
                            class="a-fx-none"
                            [alert]="alert"
                            [size]="20"
                        ></adspt-alerts-severity-icon>

                        <div class="h5">
                            {{ alert.categoryName }}
                        </div>
                    </div>

                    <div class="alert-status-actions a-fx a-fx-start-center a-fx-none">
                        <adspt-alerts-status-label [alert]="alert"></adspt-alerts-status-label>

                        <nz-divider nzType="vertical"></nz-divider>

                        <span>
                            {{ alert.createdAt | formatDate }}
                        </span>

                        <nz-divider nzType="vertical"></nz-divider>

                        <adspt-alerts-more-actions [alert]="alert" size="small"></adspt-alerts-more-actions>
                    </div>
                </div>
                <div class="alert-content">
                    <adspt-alerts-info [alert]="alert"></adspt-alerts-info>
                </div>

                <adspt-alerts-actions
                    [alert]="alert"
                    class="alert-actions a-fx a-fx-between-center"
                ></adspt-alerts-actions>
            </div>

            <adspt-alerts-no-data
                *ngIf="!(initLoadingAlerts$ | async) && !alerts.length"
                [compact]="true"
            ></adspt-alerts-no-data>
        </div>
    </adspt-spinner-overlay>
</div>
